import Button from "Components/button/button";
import React, { memo, useCallback } from "react";
import locale from "./yesNoConfirmation.inner.locale";
import Close from "Components/close";
const handleStopPropagation = (evt) => {
    evt.stopPropagation();
};
function YesNoConfirmationInner(props) {
    const handleYesButtonClick = useCallback(() => {
        var _a, _b;
        ((_b = (_a = props.popoverRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.instance) && props.popoverRef.current.instance.hide();
        props.onConfirm && props.onConfirm();
    }, [props.popoverRef]);
    const handleNoButtonClick = useCallback(() => {
        var _a, _b;
        ((_b = (_a = props.popoverRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.instance) && props.popoverRef.current.instance.hide();
    }, [props.popoverRef]);
    return (React.createElement("div", { onClick: handleStopPropagation, className: "modal-padding modal-border-radius" },
        props.headerTitle && (React.createElement("div", { className: "flex-box-centered-content h-space-between-content mb-gap" },
            React.createElement("span", { className: "text-light-on-surface fw-6 font-h4" }, props.headerTitle),
            React.createElement(Close, { onClick: handleNoButtonClick, className: "text-light-on-surface" }))),
        React.createElement("div", { className: "stretch-to-popup-size" },
            React.createElement("div", { className: "font-h5 text-overflow-ellipsis pre-wrap text-light-on-surface-variant" }, props.title),
            props.description && (React.createElement("div", { className: "text-muted font-base text-overflow-ellipsis pre-wrap" }, props.description))),
        React.createElement("div", { className: "d-flex justify-content-flex-end with-gap-8 mt-24" },
            React.createElement(Button, { className: "btn-h-m p-8-24", onClick: handleNoButtonClick, minWidth: 101 }, props.noLabel),
            React.createElement(Button, { className: "btn-primary btn-h-m p-8-24", onClick: handleYesButtonClick, minWidth: 120 }, props.yesLabel))));
}
export default memo(YesNoConfirmationInner);
YesNoConfirmationInner.defaultProps = {
    yesLabel: locale.YES,
    noLabel: locale.NO
};
